
export const saveToLocalStorage = (type, accessToken) => {
   localStorage.setItem(type, JSON.stringify(accessToken))
}

